export default [
  'test',
  'aaa',
  'aarp',
  'abarth',
  'abb',
  'abbott',
  'abbvie',
  'abc',
  'able',
  'abogado',
  'abudhabi',
  'ac',
  'academy',
  'accenture',
  'accountant',
  'accountants',
  'aco',
  'eth',
  'actor',
  'ad',
  'adac',
  'ads',
  'adult',
  'aeg',
  'aetna',
  'af',
  'afamilycompany',
  'afl',
  'africa',
  'ag',
  'agakhan',
  'agency',
  'aig',
  'aigo',
  'airbus',
  'airforce',
  'airtel',
  'akdn',
  'alfaromeo',
  'alibaba',
  'alipay',
  'allfinanz',
  'allstate',
  'ally',
  'alsace',
  'alstom',
  'am',
  'americanexpress',
  'americanfamily',
  'amex',
  'amfam',
  'amica',
  'amsterdam',
  'analytics',
  'android',
  'anquan',
  'anz',
  'aol',
  'apartments',
  'app',
  'apple',
  'aquarelle',
  'ar',
  'arab',
  'aramco',
  'archi',
  'army',
  'arpa',
  'art',
  'arte',
  'asda',
  'asia',
  'associates',
  'at',
  'athleta',
  'attorney',
  'au',
  'auction',
  'audi',
  'audible',
  'audio',
  'auspost',
  'author',
  'auto',
  'autos',
  'avianca',
  'aw',
  'aws',
  'ax',
  'axa',
  'az',
  'azure',
  'baby',
  'baidu',
  'banamex',
  'bananarepublic',
  'band',
  'bank',
  'bar',
  'barcelona',
  'barclaycard',
  'barclays',
  'barefoot',
  'bargains',
  'baseball',
  'basketball',
  'bauhaus',
  'bayern',
  'bbc',
  'bbt',
  'bbva',
  'bcg',
  'bcn',
  'be',
  'beats',
  'beauty',
  'beer',
  'bentley',
  'berlin',
  'best',
  'bestbuy',
  'bet',
  'bg',
  'bharti',
  'bible',
  'bid',
  'bike',
  'bing',
  'bingo',
  'bio',
  'biz',
  'black',
  'blackfriday',
  'blockbuster',
  'blog',
  'bloomberg',
  'blue',
  'bm',
  'bms',
  'bmw',
  'bnl',
  'bnpparibas',
  'boats',
  'boehringer',
  'bofa',
  'bom',
  'bond',
  'boo',
  'book',
  'booking',
  'bosch',
  'bostik',
  'boston',
  'bot',
  'boutique',
  'box',
  'br',
  'bradesco',
  'bridgestone',
  'broadway',
  'broker',
  'brother',
  'brussels',
  'bt',
  'budapest',
  'bugatti',
  'build',
  'builders',
  'business',
  'buy',
  'buzz',
  'bw',
  'by',
  'bz',
  'bzh',
  'ca',
  'cab',
  'cafe',
  'cal',
  'call',
  'calvinklein',
  'cam',
  'camera',
  'camp',
  'cancerresearch',
  'canon',
  'capetown',
  'capital',
  'capitalone',
  'car',
  'caravan',
  'cards',
  'care',
  'career',
  'careers',
  'cars',
  'cartier',
  'casa',
  'case',
  'caseih',
  'cash',
  'casino',
  'cat',
  'catering',
  'catholic',
  'cba',
  'cbn',
  'cbre',
  'cbs',
  'cc',
  'ceb',
  'center',
  'ceo',
  'cern',
  'cfa',
  'cfd',
  'ch',
  'chanel',
  'channel',
  'charity',
  'chase',
  'chat',
  'cheap',
  'chintai',
  'christmas',
  'chrome',
  'chrysler',
  'church',
  'cipriani',
  'circle',
  'cisco',
  'citadel',
  'citi',
  'citic',
  'city',
  'cityeats',
  'cl',
  'claims',
  'cleaning',
  'click',
  'clinic',
  'clinique',
  'clothing',
  'cloud',
  'club',
  'clubmed',
  'cn',
  'co',
  'coach',
  'codes',
  'coffee',
  'college',
  'cologne',
  'com',
  'comcast',
  'commbank',
  'community',
  'company',
  'compare',
  'computer',
  'comsec',
  'condos',
  'construction',
  'consulting',
  'contact',
  'contractors',
  'cooking',
  'cookingchannel',
  'cool',
  'coop',
  'corsica',
  'country',
  'coupon',
  'coupons',
  'courses',
  'cr',
  'credit',
  'creditcard',
  'creditunion',
  'cricket',
  'crown',
  'crs',
  'cruise',
  'cruises',
  'csc',
  'cuisinella',
  'cx',
  'cymru',
  'cyou',
  'cz',
  'dabur',
  'dad',
  'dance',
  'data',
  'date',
  'dating',
  'datsun',
  'day',
  'dclk',
  'dds',
  'de',
  'deal',
  'dealer',
  'deals',
  'degree',
  'delivery',
  'dell',
  'deloitte',
  'delta',
  'democrat',
  'dental',
  'dentist',
  'desi',
  'design',
  'dev',
  'dhl',
  'diamonds',
  'diet',
  'digital',
  'direct',
  'directory',
  'discount',
  'discover',
  'dish',
  'diy',
  'dk',
  'dnp',
  'docs',
  'doctor',
  'dodge',
  'dog',
  'doha',
  'domains',
  'dot',
  'download',
  'drive',
  'dtv',
  'dubai',
  'duck',
  'dunlop',
  'duns',
  'dupont',
  'durban',
  'dvag',
  'dvr',
  'earth',
  'eat',
  'eco',
  'edeka',
  'edu',
  'education',
  'ee',
  'email',
  'emerck',
  'energy',
  'engineer',
  'engineering',
  'enterprises',
  'epson',
  'equipment',
  'ericsson',
  'erni',
  'es',
  'esq',
  'estate',
  'esurance',
  'etisalat',
  'eu',
  'eurovision',
  'eus',
  'events',
  'everbank',
  'exchange',
  'expert',
  'exposed',
  'express',
  'extraspace',
  'fage',
  'fail',
  'fairwinds',
  'faith',
  'family',
  'fan',
  'fans',
  'farm',
  'farmers',
  'fashion',
  'fast',
  'fedex',
  'feedback',
  'ferrari',
  'ferrero',
  'fi',
  'fiat',
  'fidelity',
  'fido',
  'film',
  'final',
  'finance',
  'financial',
  'fire',
  'firestone',
  'firmdale',
  'fish',
  'fishing',
  'fit',
  'fitness',
  'flickr',
  'flights',
  'flir',
  'florist',
  'flowers',
  'fly',
  'fo',
  'foo',
  'food',
  'foodnetwork',
  'football',
  'ford',
  'forex',
  'forsale',
  'forum',
  'foundation',
  'fox',
  'fr',
  'free',
  'fresenius',
  'frl',
  'frogans',
  'frontdoor',
  'frontier',
  'ftr',
  'fujitsu',
  'fujixerox',
  'fun',
  'fund',
  'furniture',
  'futbol',
  'fyi',
  'gal',
  'gallery',
  'gallo',
  'gallup',
  'game',
  'games',
  'gap',
  'garden',
  'gbiz',
  'gd',
  'gdn',
  'gea',
  'gent',
  'genting',
  'george',
  'ggee',
  'gi',
  'gift',
  'gifts',
  'gives',
  'giving',
  'gl',
  'glade',
  'glass',
  'gle',
  'global',
  'globo',
  'gmail',
  'gmbh',
  'gmo',
  'gmx',
  'gn',
  'godaddy',
  'gold',
  'goldpoint',
  'golf',
  'goo',
  'goodyear',
  'goog',
  'google',
  'gop',
  'got',
  'gov',
  'gr',
  'grainger',
  'graphics',
  'gratis',
  'green',
  'gripe',
  'grocery',
  'group',
  'gs',
  'guardian',
  'gucci',
  'guge',
  'guide',
  'guitars',
  'guru',
  'gw',
  'hair',
  'hamburg',
  'hangout',
  'haus',
  'hbo',
  'hdfc',
  'hdfcbank',
  'health',
  'healthcare',
  'help',
  'helsinki',
  'here',
  'hermes',
  'hgtv',
  'hiphop',
  'hisamitsu',
  'hitachi',
  'hiv',
  'hk',
  'hkt',
  'hn',
  'hockey',
  'holdings',
  'holiday',
  'homedepot',
  'homegoods',
  'homes',
  'homesense',
  'honda',
  'honeywell',
  'horse',
  'hospital',
  'host',
  'hosting',
  'hot',
  'hoteles',
  'hotels',
  'hotmail',
  'house',
  'how',
  'hr',
  'hsbc',
  'hu',
  'hughes',
  'hyatt',
  'hyundai',
  'ibm',
  'icbc',
  'ice',
  'icu',
  'id',
  'ie',
  'ieee',
  'ifm',
  'ikano',
  'il',
  'imamat',
  'imdb',
  'immo',
  'immobilien',
  'in',
  'inc',
  'industries',
  'infiniti',
  'info',
  'ing',
  'ink',
  'institute',
  'insurance',
  'insure',
  'int',
  'intel',
  'international',
  'intuit',
  'investments',
  'io',
  'ipiranga',
  'irish',
  'is',
  'iselect',
  'ismaili',
  'ist',
  'istanbul',
  'it',
  'itau',
  'itv',
  'iveco',
  'jaguar',
  'java',
  'jcb',
  'jcp',
  'jeep',
  'jetzt',
  'jewelry',
  'jio',
  'jll',
  'jmp',
  'jnj',
  'jobs',
  'joburg',
  'jot',
  'joy',
  'jp',
  'jpmorgan',
  'jprs',
  'juegos',
  'juniper',
  'kaufen',
  'kddi',
  'ke',
  'kerryhotels',
  'kerrylogistics',
  'kerryproperties',
  'kfh',
  'kg',
  'ki',
  'kia',
  'kim',
  'kinder',
  'kindle',
  'kitchen',
  'kiwi',
  'koeln',
  'komatsu',
  'kosher',
  'kpmg',
  'kpn',
  'kr',
  'krd',
  'kred',
  'kuokgroup',
  'ky',
  'kyoto',
  'la',
  'lacaixa',
  'ladbrokes',
  'lamborghini',
  'lamer',
  'lancaster',
  'lancia',
  'lancome',
  'land',
  'landrover',
  'lanxess',
  'lasalle',
  'lat',
  'latino',
  'latrobe',
  'law',
  'lawyer',
  'lb',
  'lc',
  'lds',
  'lease',
  'leclerc',
  'lefrak',
  'legal',
  'lego',
  'lexus',
  'lgbt',
  'li',
  'liaison',
  'lidl',
  'life',
  'lifeinsurance',
  'lifestyle',
  'lighting',
  'like',
  'lilly',
  'limited',
  'limo',
  'lincoln',
  'linde',
  'link',
  'lipsy',
  'live',
  'living',
  'lixil',
  'lk',
  'llc',
  'loan',
  'loans',
  'locker',
  'locus',
  'loft',
  'lol',
  'london',
  'lotte',
  'lotto',
  'love',
  'lpl',
  'lplfinancial',
  'lr',
  'lt',
  'ltd',
  'ltda',
  'lu',
  'lundbeck',
  'lupin',
  'luxe',
  'luxury',
  'lv',
  'ma',
  'macys',
  'madrid',
  'maif',
  'maison',
  'makeup',
  'man',
  'management',
  'mango',
  'map',
  'market',
  'marketing',
  'markets',
  'marriott',
  'marshalls',
  'maserati',
  'mattel',
  'mba',
  'mckinsey',
  'md',
  'me',
  'med',
  'media',
  'meet',
  'melbourne',
  'meme',
  'memorial',
  'men',
  'menu',
  'merckmsd',
  'metlife',
  'mg',
  'miami',
  'microsoft',
  'mil',
  'mini',
  'mint',
  'mit',
  'mitsubishi',
  'mlb',
  'mls',
  'mm',
  'mma',
  'mn',
  'mobi',
  'mobile',
  'mobily',
  'moda',
  'moe',
  'moi',
  'mom',
  'monash',
  'money',
  'monster',
  'mopar',
  'mormon',
  'mortgage',
  'moscow',
  'moto',
  'motorcycles',
  'mov',
  'movie',
  'movistar',
  'msd',
  'mtn',
  'mtr',
  'museum',
  'mutual',
  'mx',
  'my',
  'na',
  'nab',
  'nadex',
  'nagoya',
  'name',
  'nationwide',
  'natura',
  'navy',
  'nba',
  'nc',
  'nec',
  'net',
  'netbank',
  'netflix',
  'network',
  'neustar',
  'new',
  'newholland',
  'news',
  'next',
  'nextdirect',
  'nexus',
  'nf',
  'nfl',
  'ngo',
  'nhk',
  'nico',
  'nike',
  'nikon',
  'ninja',
  'nissan',
  'nissay',
  'nl',
  'no',
  'nokia',
  'northwesternmutual',
  'norton',
  'now',
  'nowruz',
  'nowtv',
  'nra',
  'nrw',
  'ntt',
  'nu',
  'nyc',
  'nz',
  'obi',
  'observer',
  'off',
  'office',
  'okinawa',
  'olayan',
  'olayangroup',
  'oldnavy',
  'ollo',
  'omega',
  'one',
  'ong',
  'onl',
  'online',
  'onyourside',
  'ooo',
  'open',
  'oracle',
  'orange',
  'org',
  'organic',
  'origins',
  'osaka',
  'otsuka',
  'ott',
  'ovh',
  'page',
  'panasonic',
  'paris',
  'pars',
  'partners',
  'parts',
  'party',
  'passagens',
  'pay',
  'pccw',
  'pe',
  'pet',
  'pfizer',
  'pharmacy',
  'phd',
  'philips',
  'phone',
  'photo',
  'photography',
  'photos',
  'physio',
  'piaget',
  'pics',
  'pictet',
  'pictures',
  'pid',
  'pin',
  'ping',
  'pink',
  'pioneer',
  'pizza',
  'pl',
  'place',
  'play',
  'playstation',
  'plumbing',
  'plus',
  'pm',
  'pnc',
  'pohl',
  'poker',
  'politie',
  'porn',
  'post',
  'pr',
  'pramerica',
  'praxi',
  'press',
  'prime',
  'pro',
  'prod',
  'productions',
  'prof',
  'progressive',
  'promo',
  'properties',
  'property',
  'protection',
  'pru',
  'prudential',
  'pt',
  'pub',
  'pw',
  'pwc',
  'qpon',
  'quebec',
  'quest',
  'qvc',
  'racing',
  'radio',
  'raid',
  're',
  'read',
  'realestate',
  'realtor',
  'realty',
  'recipes',
  'red',
  'redstone',
  'redumbrella',
  'rehab',
  'reise',
  'reisen',
  'reit',
  'reliance',
  'ren',
  'rent',
  'rentals',
  'repair',
  'report',
  'republican',
  'rest',
  'restaurant',
  'review',
  'reviews',
  'rexroth',
  'rich',
  'richardli',
  'ricoh',
  'rightathome',
  'ril',
  'rio',
  'rip',
  'rmit',
  'ro',
  'rocher',
  'rocks',
  'rodeo',
  'rogers',
  'room',
  'rsvp',
  'ru',
  'rugby',
  'ruhr',
  'run',
  'rwe',
  'ryukyu',
  'sa',
  'saarland',
  'safe',
  'safety',
  'sakura',
  'sale',
  'salon',
  'samsclub',
  'samsung',
  'sandvik',
  'sandvikcoromant',
  'sanofi',
  'sap',
  'sarl',
  'sas',
  'save',
  'saxo',
  'sb',
  'sbi',
  'sbs',
  'sc',
  'sca',
  'scb',
  'schaeffler',
  'schmidt',
  'scholarships',
  'school',
  'schule',
  'schwarz',
  'science',
  'scjohnson',
  'scor',
  'scot',
  'se',
  'search',
  'seat',
  'secure',
  'security',
  'seek',
  'select',
  'sener',
  'services',
  'ses',
  'seven',
  'sew',
  'sex',
  'sexy',
  'sfr',
  'sg',
  'sh',
  'shangrila',
  'sharp',
  'shaw',
  'shell',
  'shia',
  'shiksha',
  'shoes',
  'shop',
  'shopping',
  'shouji',
  'show',
  'showtime',
  'shriram',
  'si',
  'silk',
  'sina',
  'singles',
  'site',
  'sj',
  'ski',
  'skin',
  'sky',
  'skype',
  'sling',
  'smart',
  'smile',
  'sn',
  'sncf',
  'soccer',
  'social',
  'softbank',
  'software',
  'sohu',
  'solar',
  'solutions',
  'song',
  'sony',
  'soy',
  'space',
  'sport',
  'spot',
  'spreadbetting',
  'srl',
  'srt',
  'stada',
  'staples',
  'star',
  'starhub',
  'statebank',
  'statefarm',
  'stc',
  'stcgroup',
  'stockholm',
  'storage',
  'store',
  'stream',
  'studio',
  'study',
  'style',
  'su',
  'sucks',
  'supplies',
  'supply',
  'support',
  'surf',
  'surgery',
  'suzuki',
  'swatch',
  'swiftcover',
  'swiss',
  'sx',
  'sydney',
  'symantec',
  'systems',
  'tab',
  'taipei',
  'talk',
  'taobao',
  'target',
  'tatamotors',
  'tatar',
  'tattoo',
  'tax',
  'taxi',
  'tci',
  'tdk',
  'team',
  'tech',
  'technology',
  'tel',
  'telefonica',
  'temasek',
  'tennis',
  'teva',
  'tf',
  'th',
  'thd',
  'theater',
  'theatre',
  'tiaa',
  'tickets',
  'tienda',
  'tiffany',
  'tips',
  'tires',
  'tirol',
  'tjmaxx',
  'tjx',
  'tkmaxx',
  'tl',
  'tm',
  'tmall',
  'tn',
  'today',
  'tokyo',
  'tools',
  'top',
  'toray',
  'toshiba',
  'total',
  'tours',
  'town',
  'toyota',
  'toys',
  'trade',
  'trading',
  'training',
  'travel',
  'travelchannel',
  'travelers',
  'travelersinsurance',
  'trust',
  'trv',
  'tt',
  'tube',
  'tui',
  'tunes',
  'tushu',
  'tv',
  'tvs',
  'tw',
  'tz',
  'ua',
  'ubank',
  'ubs',
  'uconnect',
  'ug',
  'uk',
  'unicom',
  'university',
  'uno',
  'uol',
  'ups',
  'us',
  'uy',
  'vacations',
  'vana',
  'vanguard',
  'vc',
  'vegas',
  'ventures',
  'verisign',
  'versicherung',
  'vet',
  'viajes',
  'video',
  'vig',
  'viking',
  'villas',
  'vin',
  'vip',
  'virgin',
  'visa',
  'vision',
  'vistaprint',
  'viva',
  'vivo',
  'vlaanderen',
  'vn',
  'vodka',
  'volkswagen',
  'volvo',
  'vote',
  'voting',
  'voto',
  'voyage',
  'vu',
  'vuelos',
  'wales',
  'walmart',
  'walter',
  'wang',
  'wanggou',
  'warman',
  'watch',
  'watches',
  'weather',
  'weatherchannel',
  'webcam',
  'weber',
  'website',
  'wed',
  'wedding',
  'weibo',
  'weir',
  'wf',
  'whoswho',
  'wien',
  'wiki',
  'williamhill',
  'win',
  'windows',
  'wine',
  'winners',
  'wme',
  'wolterskluwer',
  'woodside',
  'work',
  'works',
  'world',
  'wow',
  'ws',
  'wtc',
  'wtf',
  'xbox',
  'xerox',
  'xfinity',
  'xihuan',
  'xin',
  'xn--11b4c3d.   कॉम',
  'xn--1ck2e1b.   セール',
  'xn--1qqw23a.   佛山',
  'xn--2scrj9c.   ಭಾರತ',
  'xn--30rr7y.   慈善',
  'xn--3bst00m.   集团',
  'xn--3ds443g.   在线',
  'xn--3e0b707e.   한국',
  'xn--3hcrj9c.   ଭାରତ',
  'xn--3oq18vl8pn36a.   大众汽车',
  'xn--3pxu8k.   点看',
  'xn--42c2d9a.   คอม',
  'xn--45br5cyl.   ভাৰত',
  'xn--45brj9c.   ভারত',
  'xn--45q11c.   八卦',
  'xn--4gbrim.   موقع',
  'xn--55qw42g.   公益',
  'xn--55qx5d.   公司',
  'xn--5su34j936bgsg.   香格里拉',
  'xn--5tzm5g.   网站',
  'xn--6frz82g.   移动',
  'xn--6qq986b3xl.   我爱你',
  'xn--80adxhks.   москва',
  'xn--80aqecdr1a.   католик',
  'xn--80asehdb.   онлайн',
  'xn--80aswg.   сайт',
  'xn--8y0a063a.   联通',
  'xn--90ae.   бг',
  'xn--9dbq2a.   קום',
  'xn--9et52u.   时尚',
  'xn--9krt00a.   微博',
  'xn--b4w605ferd.   淡马锡',
  'xn--bck1b9a5dre4c.   ファッション',
  'xn--c1avg.   орг',
  'xn--c2br7g.   नेट',
  'xn--cck2b3b.   ストア',
  'xn--cg4bki.   삼성',
  'xn--clchc0ea0b2g2a9gcd.   சிங்கப்பூர்',
  'xn--czr694b.   商标',
  'xn--czrs0t.   商店',
  'xn--czru2d.   商城',
  'xn--d1acj3b.   дети',
  'xn--e1a4c.   ею',
  'xn--eckvdtc9d.   ポイント',
  'xn--efvy88h.   新闻',
  'xn--estv75g.   工行',
  'xn--fct429k.   家電',
  'xn--fhbei.   كوم',
  'xn--fiq228c5hs.   中文网',
  'xn--fiq64b.   中信',
  'xn--fiqs8s.   中国',
  'xn--fiqz9s.   中國',
  'xn--fjq720a.   娱乐',
  'xn--flw351e.   谷歌',
  'xn--fpcrj9c3d.   భారత్',
  'xn--fzys8d69uvgm.   電訊盈科',
  'xn--g2xx48c.   购物',
  'xn--gckr3f0f.   クラウド',
  'xn--gecrj9c.   ભારત',
  'xn--gk3at1e.   通販',
  'xn--h2breg3eve.   भारतम्',
  'xn--h2brj9c.   भारत',
  'xn--h2brj9c8c.   भारोत',
  'xn--hxt814e.   网店',
  'xn--i1b6b1a6a2e.   संगठन',
  'xn--imr513n.   餐厅',
  'xn--io0a7i.   网络',
  'xn--j1aef.   ком',
  'xn--j6w193g.   香港',
  'xn--jlq61u9w7b.   诺基亚',
  'xn--jvr189m.   食品',
  'xn--kcrx77d1x4a.   飞利浦',
  'xn--kprw13d.   台湾',
  'xn--kpry57d.   台灣',
  'xn--kpu716f.   手表',
  'xn--kput3i.   手机',
  'xn--l1acc.   мон',
  'xn--mgba3a3ejt.   ارامكو',
  'xn--mgba7c0bbn0a.   العليان',
  'xn--mgbaakc7dvf.   اتصالات',
  'xn--mgbab2bd.   بازار',
  'xn--mgbai9azgqp6j.   پاکستان',
  'xn--mgbb9fbpob.   موبايلي',
  'xn--mgbbh1a.   بارت',
  'xn--mgbbh1a71e.   بھارت',
  'xn--mgbca7dzdo.   ابوظبي',
  'xn--mgberp4a5d4ar.   السعودية',
  'xn--mgbgu82a.   ڀارت',
  'xn--mgbi4ecexp.   كاثوليك',
  'xn--mgbt3dhd.   همراه',
  'xn--mgbx4cd0ab.   مليسيا',
  'xn--mk1bu44c.   닷컴',
  'xn--mxtq1m.   政府',
  'xn--ngbc5azd.   شبكة',
  'xn--ngbe9e0a.   بيتك',
  'xn--ngbrx.   عرب',
  'xn--nqv7f.   机构',
  'xn--nqv7fs00ema.   组织机构',
  'xn--nyqy26a.   健康',
  'xn--o3cw4h.   ไทย',
  'xn--otu796d.   招聘',
  'xn--p1acf.   рус',
  'xn--p1ai.   рф',
  'xn--pbt977c.   珠宝',
  'xn--pgbs0dh.   تونس',
  'xn--pssy2u.   大拿',
  'xn--q9jyb4c.   みんな',
  'xn--qcka1pmc.   グーグル',
  'xn--qxam.   ελ',
  'xn--rhqv96g.   世界',
  'xn--rovu88b.   書籍',
  'xn--rvc1e0am3e.   ഭാരതം',
  'xn--s9brj9c.   ਭਾਰਤ',
  'xn--ses554g.   网址',
  'xn--t60b56a.   닷넷',
  'xn--tckwe.   コム',
  'xn--tiq49xqyj.   天主教',
  'xn--unup4y.   游戏',
  'xn--vermgensberater-ctb.   vermögensberater',
  'xn--vermgensberatung-pwb.   vermögensberatung',
  'xn--vhquv.   企业',
  'xn--vuq861b.   信息',
  'xn--w4r85el8fhu5dnra.   嘉里大酒店',
  'xn--w4rs40l.   嘉里',
  'xn--wgbh1c.   مصر',
  'xn--xhq521b.   广东',
  'xn--xkc2dl3a5ee0h.   இந்தியா',
  'xn--y9a3aq.   հայ',
  'xn--yfro4i67o.   新加坡',
  'xn--zfr164b.   政务',
  'xxx',
  'xyz',
  'yachts',
  'yahoo',
  'yamaxun',
  'yandex',
  'yodobashi',
  'yoga',
  'yokohama',
  'you',
  'youtube',
  'yt',
  'yun',
  'za',
  'zappos',
  'zara',
  'zero',
  'zip',
  'zm',
  'zone',
  'zuerich'
];
